var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg10(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 142.51 127.1"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M53.87 125.4H29.31V30.76L0 39.85v-20L51.23 1.53h2.64zM142.51 74.26q0 25.65-10.62 39.25T100.8 127.1q-20.22 0-30.93-13.34t-11-38.23V52.76q0-25.9 10.75-39.34T100.63 0q20.22 0 30.92 13.3t11 38.19zM118 49.22q0-15.39-4.21-22.41t-13.12-7q-8.67 0-12.79 6.67t-4.41 20.87v30.11q0 15.14 4.12 22.49t13.21 7.36q9 0 13-7.06t4.2-21.6z"
  })));
}
Svg10.displayName = '10';
export default Svg10;